(() => {
	const siteName = 'digisystem';
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const htmlHasClass = (_class) => { return document.documentElement.classList.contains(_class); };
	const checkRegion = () => {
		let pathDirList = location.pathname.split('/');
		let region = '/';
		switch (pathDirList[1]) {
			case 'be': region = `/${pathDirList[1]}/${pathDirList[2]}/`; break;
			case 'ca': region = `/${pathDirList[1]}/${pathDirList[2]}/`; break;
			case 'de': region = `/${pathDirList[1]}/`; break;
			case 'es': region = `/${pathDirList[1]}/`; break;
			case 'fr': region = `/${pathDirList[1]}/`; break;
			case 'in': region = `/${pathDirList[1]}/`; break;
			case 'it': region = `/${pathDirList[1]}/`; break;
			case 'sg': region = `/${pathDirList[1]}/`; break;
			case 'tr': region = `/${pathDirList[1]}/`; break;
			case 'uk': region = `/${pathDirList[1]}/`; break;
			case 'us': region = `/${pathDirList[1]}/`; break;
			case 'cn': region = `/${pathDirList[1]}/`; break;
			case 'jp': region = `/${pathDirList[1]}/`; break;
			case 'kr': region = `/${pathDirList[1]}/`; break;
			default: break;
		}
		return region;
	};
	const checkMapCat = () => {
		let mapCat = ''; // カテゴリチェック
		let map2 = (checkRegion() === '/') ? location.pathname.split('/')[1] : location.pathname.replace(new RegExp(checkRegion(), 'g'), '').split('/')[0];
		if (map2 === 'retail' || map2 === 'food-industry' || map2 === 'logistics' || map2 === 'hospitality' || map2 === 'service-and-cloud') {
			mapCat = map2;
		} else if (location.search.indexOf('business=') !== -1) { // クエリストリングがある場合
			location.search.replace(/\?/g, '').split('&').forEach(ele => {
				if (ele.indexOf('business=') !== -1) {
					mapCat = ele.split('=')[1];
				}
			});
		} else if (document.querySelector('.products-detail')) { // 製品詳細
			if (document.querySelector('.rt_business_main')) {
				mapCat = document.querySelector('.rt_business_main').getAttribute('data-main');
			}
		} else if (document.querySelector('.topics-detail')) { // トピックス詳細
			if (document.querySelector('.rt_n_tags_m_category')) {
				mapCat = document.querySelector('.rt_n_tags_m_category').getAttribute('data-main');
			}
		} else if (document.querySelector('.solutions-detail') || document.querySelector('.case-detail')) { // ソリューション／事例詳細
			if (document.querySelector('.rt_business_category')) {
				mapCat = document.querySelector('.rt_business_category').getAttribute('data-main');
			}
		}
		return mapCat;
	};

	FUNCTIONS = {
		va: {
			pathname: location.pathname,
			region: checkRegion(),
			mapCat: checkMapCat(),
			isMobile: htmlHasClass('ua-mobile'),
			device: {
				desktop: 1024,
				sp: 768
			},
			window: {
				width: window.innerWidth,
				height: window.innerHeight
			},
			header: {
				desktop: 100,
				sp: 60
			}
		},
		localDecision() {
			const regExp = new RegExp(`(test\\.${siteName}\\.connecty\\.co\\.jp|copre\\.jp|localhost|192\\.168\\.|100\\.64\\.)`, 'g');
			return regExp.test(location.hostname);
		},
		localLoading() { // ローカル環境ならincludeをAjaxで読み込む
			const _this = this;
			const key = 'inc_';
			let ajaxArray = [];
			let ajaxArrayList = [];
			let includeClass = document.querySelectorAll(`[class*="${key}"]`);

			includeClass.forEach(ele => {
				let path = ele.innerHTML.split(' ')[1];
				ajaxArray.push(path);
			});

			if (ajaxArray.length) {
				ajaxArray.forEach(ele => {
					let xhr = new XMLHttpRequest();
					let promise = new Promise((resolve, reject) => {
						xhr.onreadystatechange = () => {
							if (xhr.readyState === 4) {
								if (xhr.status === 200) {
									resolve(xhr.responseText);
								} else {
									reject(xhr.statusText);
								}
							}
						};
					});
					xhr.open('GET', ele + '.html', true);
					xhr.send();
					ajaxArrayList.push(promise);
				});

				Promise.all(ajaxArrayList).then(results => {
					let regExp = new RegExp(key);

					results.forEach(ele => {
						let classList = ele.split(/ |\"/g);
						let position;

						classList.forEach(ele2 => {
							if (ele2.match(regExp)) { position = ele2; }
						});
						document.querySelectorAll('.' + position).forEach(ele2 => {
							ele2.outerHTML = ele;
						});
						console.log('Succeeded to read the include file!:', position);
					});

					_this.loadDelayScript();
				}).catch((error) => {
					console.error('Failed to read the include file:', error);
					_this.loadDelayScript();
				});
			} else {
				_this.loadDelayScript();
			}
		},
		getQuery() {
			let vars = [];
			let hash = null;
			let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
			hashes.forEach(ele => {
				hash = ele.split('=');
				hash[1] = (hash[1].indexOf('#') !== -1) ? hash[1].split('#')[0] : hash[1];
				vars.push(hash[0]);
				vars[hash[0]] = hash[1];
			});
			return vars;
		},
		nextToggle() {
			const switchElements = document.querySelectorAll('.js-toggle');

			switchElements.forEach(switchElement => {
				switchElement.addEventListener('click', (e) => {
					e.currentTarget.classList.toggle(a);

					let toggleBlock = e.currentTarget.nextElementSibling;
					toggleBlock.classList.toggle(a);
					if (toggleBlock.style.height) {
						toggleBlock.style.height = null;
					} else {
						toggleBlock.style.height = toggleBlock.scrollHeight + 'px';
					}
				});
			});
		},
		tabSwitch() {
			let $tab = document.querySelectorAll('.js-tab');
			let $content = document.querySelectorAll('.js-tab-content');
			if ($tab.length) {
				// ハッシュタグで絞り込み
				if (location.hash) {
					let hash = location.hash.split('#')[1];
					$tab.forEach((ele) => {
						ele.classList.remove(a);
						if (ele.getAttribute('data-target').match(hash)) {
							ele.classList.remove(a);
						}
					});
					$content.forEach((ele) => {
						ele.classList.remove(a);
						ele.classList.remove(v);
						if (ele.getAttribute('data-target').match(hash)) {
							$(ele).addClass(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						}
					});
				}

				$tab.forEach((ele) => {
					ele.addEventListener('click', () => {
						$tab.forEach((ele2) => { ele2.classList.remove(a); })
						ele.classList.add(a);
						$content.forEach((ele) => {
							ele.classList.remove(a);
							ele.classList.remove(v);
						});

						let $target;
						let target = ele.getAttribute('data-target');
						if (target === 'all') {
							$target = $content;
						} else {
							$target = document.querySelectorAll(`[data-target="${target}"]`);
						}
						$target.forEach((ele) => {
							ele.classList.add(a);
							setTimeout(() => { ele.classList.add(v); }, 200);
						});

						if (ele.closest('.company-localNav._bottom')) {
							let anchorNavH = 43;
							let pos = document.querySelector(`[data-target="${target}"]`).getBoundingClientRect().top;
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos = pos - FUNCTIONS.va.header.sp - anchorNavH;
							} else {
								pos = pos - FUNCTIONS.va.header.desktop - anchorNavH;
							}
							window.scrollTo({ top: pos, behavior: 'smooth' });
						}
					});
				});
			}
		},
		easeScroll() {
			const scrollToObject = (_self) => {
				let anchorNavH = 43;
				let hash = _self.currentTarget.href.split('#')[1];
				let pos = hash === 'pagetop' ? 0 : document.getElementById(hash).getBoundingClientRect().top;
				let offset = hash === 'pagetop' ? 0 : window.scrollY;
				pos += offset;

				if (hash !== 'pagetop') {
					if (document.querySelector('.mod-anchorNav')) {
						if (document.querySelector(`#${hash}`).getBoundingClientRect().top < 0) {
							// 上に戻る
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos = pos - FUNCTIONS.va.header.sp - anchorNavH;
							} else {
								pos = pos - FUNCTIONS.va.header.desktop - anchorNavH;
							}
						} else {
							 // 下に進む
							pos = pos - anchorNavH - 50; // viewAnimationの分
						}
					} else {
						if (document.querySelector(`#${hash}`).getBoundingClientRect().top < 0) {
							if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
								pos = pos - FUNCTIONS.va.header.sp;
							} else {
								pos = pos - FUNCTIONS.va.header.desktop;
							}
						}
					}
				}
				window.scrollTo({ top: pos, behavior: 'smooth' });
			}
			document.querySelectorAll('a[rel="scroll"]').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					e.preventDefault();
					if (/#/.test(e.currentTarget.href)) {
						scrollToObject(e);
						return false;
					}
				});
			});
		},
		easeScrollHash() {
			const hash = location.hash;
			if (hash) {
				window.addEventListener('load', () => {
					document.documentElement.style.display = 'none';
					document.body.style.display = 'none';

					setTimeout(() => {
						document.documentElement.style.display = 'block';
						document.body.style.display = 'block';

						let pos = document.getElementById(hash.split('#')[1]).getBoundingClientRect().top;

						if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
							pos -= FUNCTIONS.va.header.sp;
						} else {
							pos -= FUNCTIONS.va.header.desktop;
						}
						if (document.querySelector('.mod-anchorNav')) {
							pos -= 43;
						}
						window.scrollTo({ top: pos, behavior: 'smooth' });
					}, 100);
				});
			}
		},
		pageTop() {
			let footer = document.querySelector('.footer');
			let $pagetop = document.querySelector('.footer-pagetop');

			window.addEventListener('scroll', (e) => {
				if (window.scrollY > '100') {
					$pagetop.classList.add(v);
				} else {
					$pagetop.classList.remove(v);
				}
			});
		},
		footerContactPos () {
			window.addEventListener('scroll', () => {
				let scrollHeight = document.body.clientHeight;
				let footerHeight = document.querySelector('.footer').clientHeight + window.innerHeight;
				let $footerContact = document.querySelector('.footer .mod-contact');
				let time;

				if (window.scrollY > 150) {
					clearTimeout(time);
					if (!$footerContact.classList.contains('is-active')) {
						$footerContact.classList.add('is-active');
						time = setTimeout(() => { $footerContact.classList.add('is-visible'); }, 10);
					}
				} else {
					clearTimeout(time);
					if ($footerContact.classList.contains('is-active')) {
						$footerContact.classList.remove('is-visible');
						time = setTimeout(() => { $footerContact.classList.remove('is-active'); }, 400);
					}
				}
				if (scrollHeight - window.scrollY < footerHeight) {
					$footerContact.classList.add('is-bottom');
				} else {
					$footerContact.classList.remove('is-bottom');
				}
			});
		},
		setImgAttrWidthHeight() {
			const getImg = (_src) => {
				return new Promise((resolve, reject) => {
					const image = new Image();
					image.src = _src;
					image.onload = () => { resolve(image); }
					image.onerror = (error) => { reject(error); }
				});
			};

			const imgs = document.getElementsByTagName('img');

			for (const img of imgs) {
				const src = img.getAttribute('src');
				getImg(src).then((res) => {
					if (!img.hasAttribute('width')) {
						img.setAttribute('width', res.width);
					}
					if (!img.hasAttribute('height')) {
						img.setAttribute('height', res.height);
					}
				})
				.catch((error) => { console.log(error); });
			}
		},
		fixedOnContainer(_scrollTop) {
			let $container = document.querySelector('.container');
			$container.style.position = 'fixed';
			$container.style.width = '100%';
			$container.style.top = (-1 * _scrollTop) + 'px';
			$container.style.left = 0;
			document.body.classList.add(f);
		},
		fixedOffContainer(_scrollTop) {
			let $container = document.querySelector('.container');
			$container.style.position = 'static';
			$container.style.top = 'auto';
			document.body.classList.remove(f);
			window.scrollTo({ top: _scrollTop });
		},
		setModal() {
			const createModal = (_appendHTML) => {
				const $container = document.createElement('div');
				$container.className = 'mod-modal-overlay';
				$container.innerHTML = _appendHTML;
				document.body.appendChild($container);

				$container.classList.add(a);
				setTimeout(() => {
					$container.classList.add(v);
					document.querySelectorAll('.mod-modal-closeArea, .mod-modal-closeBtn, .mod-modalContent a').forEach((ele) => {
						ele.addEventListener('click', (e) => {
							$container.classList.remove(v);
							setTimeout(() => {
								$container.classList.remove(a);
								$container.remove();
							}, 400);
						});
					});
				});
			};

			document.querySelectorAll('.mod-modal').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let targetKey = e.currentTarget.getAttribute('data-target');
					let $content = document.querySelector(`.mod-modalContent[data-target="${targetKey}"]`);
					if ($content.outerHTML) {
						let appendHTML = `<div class="mod-modal-closeArea"></div>
							<span class="mod-modal-closeBtn"><svg><use xlink:href="/common/svg/sprite.svg#close" /></svg></span>
							${$content.outerHTML}`;
						createModal(appendHTML);
					}
					return false;
				});
			});

			// 画像1個だけのモーダル
			document.querySelectorAll('.mod-modalImg').forEach((ele) => {
				ele.addEventListener('click', (e) => {
					let appendHTML = `<div class="mod-modal-closeArea"></div>
						<span class="mod-modal-closeBtn"><svg><use xlink:href="/common/svg/sprite.svg#close" /></svg></span>
						${e.currentTarget.querySelector('img').outerHTML}`;
					createModal(appendHTML);
				});
			});
		},
		header() {
			let $header = document.querySelector('.header');
			let $headCat = document.querySelector('.header .header-head .__category');
			let $headerNav = document.querySelector('.header-nav');
			let $headerNavLink = document.querySelectorAll('.js-headerNavItem');
			let $headerMegaNav = document.querySelectorAll('.js-megaMenu');
			let $headerTabItem = document.querySelectorAll('.header .__megaMenu__tab__item');
			let $headerTabContents = document.querySelectorAll('.header .js-headerCatItem');
			let $headerSubMenu = document.querySelectorAll('.header .js-headerSubMenu');
			let $langNavHead = document.querySelector('.header .__lang__head');
			let $langNavBody = document.querySelector('.header .__lang__body');
			let $siteSearch = document.querySelector('.header .__search');
			let $searchModal = document.querySelector('.header-searchModal');
			let $hamburger = document.querySelector('.header-hamburger');
			let $overlay = document.querySelector('.header-overlay');

			// ロゴ横 カテゴリチェックして出し分け
			switch (FUNCTIONS.va.mapCat) {
				case 'retail': $headCat.querySelector('._retail').classList.add(a); break;
				case 'food-industry': $headCat.querySelector('._food').classList.add(a); break;
				case 'logistics': $headCat.querySelector('._logistics').classList.add(a); break;
				case 'hospitality': $headCat.querySelector('._hospitality').classList.add(a); break;
				case 'service-and-cloud': $headCat.querySelector('._service').classList.add(a); break;
				default: break;
			};
			if (!$headCat.querySelector('.is-active')) {
				$headCat.remove();
			}

			// [PC] メガメニュー
			const megaMenu = () => {
				// ホバーしている大カテゴリ以外を透過する
				$headerNavLink.forEach((ele) => {
					ele.addEventListener('mouseenter', () => { $headerNav.classList.add('is-hover'); });
					ele.addEventListener('mouseleave', () => { $headerNav.classList.remove('is-hover'); });
				});
				// メガメニュー開閉
				$headerMegaNav.forEach((ele) => {
					ele.addEventListener('click', () => {
						if (ele.classList.contains(a)) {
							ele.classList.remove(a);
							ele.nextElementSibling.classList.remove(a);
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								ele.nextElementSibling.classList.remove(v);
								setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 300);
								$header.classList.remove('is-open');
								$overlay.classList.remove(v);
								setTimeout(() => { $overlay.classList.remove(a); }, 300);
							} else {
								ele.nextElementSibling.style.height = null;
							}
						} else {
							// PCの場合他のメガメニューを閉じる
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								$headerMegaNav.forEach((ele2) => {
									if (ele2.nextElementSibling.classList.contains(a)) {
										ele2.classList.remove(a);
										ele2.nextElementSibling.classList.remove(v);
										setTimeout(() => { ele2.nextElementSibling.classList.remove(a); }, 300);
									}
								});

								if (!$header.classList.contains(a)) {
									$overlay.classList.add(a);
									setTimeout(() => { $overlay.classList.add(v); }, 100);
								}
							}

							// 言語ナビ閉じる
							$langNavBody.classList.remove(v);
							setTimeout(() => { $langNavBody.classList.remove(a); }, 300);

							ele.classList.add(a);
							ele.nextElementSibling.classList.add(a);
							if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
								setTimeout(() => { ele.nextElementSibling.classList.add(v); }, 100);
								$header.classList.add('is-open');
							} else {
								ele.nextElementSibling.style.height = ele.nextElementSibling.scrollHeight + 'px';
							}
						}
					});
				});
				// オーバーレイエリア押下でメガメニューを閉じる
				$overlay.addEventListener('click', () => {
					$headerMegaNav.forEach((ele) => {
						ele.classList.remove(a);
						ele.nextElementSibling.classList.remove(v);
						setTimeout(() => { ele.nextElementSibling.classList.remove(a); }, 300);
					});
					$header.classList.remove('is-open');
					$overlay.classList.remove(v);
					setTimeout(() => { $overlay.classList.remove(a); }, 300);
				});
			};
			megaMenu();

			// [PC] タブ切り替え
			const TabSwitch = () => {
				if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
					// 初期表示
					switch (FUNCTIONS.va.mapCat) {
						case 'retail':
							document.querySelectorAll('.js-headerCatItem[data-target=retail]').forEach((ele) => { ele.classList.add(a); });
							document.querySelectorAll('.__megaMenu__tab__item[data-target=retail]').forEach((ele) => { ele.classList.add(a); });
							break;
						case 'food-industry':
							document.querySelectorAll('.js-headerCatItem[data-target=food-industry]').forEach((ele) => { ele.classList.add(a); });
							document.querySelectorAll('.__megaMenu__tab__item[data-target=food-industry]').forEach((ele) => { ele.classList.add(a); });
							break;
						case 'logistics':
							document.querySelectorAll('.js-headerCatItem[data-target=logistics]').forEach((ele) => { ele.classList.add(a); });
							document.querySelectorAll('.__megaMenu__tab__item[data-target=logistics]').forEach((ele) => { ele.classList.add(a); });
							break;
						case 'hospitality':
							document.querySelectorAll('.js-headerCatItem[data-target=hospitality]').forEach((ele) => { ele.classList.add(a); });
							document.querySelectorAll('.__megaMenu__tab__item[data-target=hospitality]').forEach((ele) => { ele.classList.add(a); });
							break;
						default:
							document.querySelectorAll('.js-headerCatItem[data-target=retail]').forEach((ele) => { ele.classList.add(a); });
							document.querySelectorAll('.__megaMenu__tab__item[data-target=retail]').forEach((ele) => { ele.classList.add(a); });
							break;
					}

					$headerTabItem.forEach((ele) => {
						ele.addEventListener('click', () => {
							let thisCat = ele.getAttribute('data-target');
							if (!ele.classList.contains(a)) {
								$headerTabItem.forEach((ele2) => {
									if (ele2.getAttribute('data-target') === thisCat) {
										ele2.classList.add(a);
									} else {
										ele2.classList.remove(a);
									}
								});
								$headerTabContents.forEach((ele2) => {
									if (ele2.getAttribute('data-target') === thisCat) {
										ele2.classList.add(a);
									} else {
										ele2.classList.remove(a);
									}
								});
							}
						});
					});
				}
			};
			TabSwitch();

			// [SP] ハンバーガーメニュー
			const setHamburger = () => {
				let scrollTop = 0;
				$hamburger.addEventListener('click', () => {
					$hamburger.classList.toggle(a);
					if ($headerNav.classList.contains(a)) {
						$header.classList.remove('is-open');
						$headerNav.classList.remove(v);
						setTimeout(() => { $headerNav.classList.remove(a); }, 400);
						this.fixedOffContainer(scrollTop);
					} else {
						scrollTop = window.scrollY;
						this.fixedOnContainer(scrollTop);
						$header.classList.add('is-open');
						$headerNav.classList.add(a);
						setTimeout(() => { $headerNav.classList.add(v); });
					}
				});
			};
			setHamburger();

			// [SP] サブメニュー開閉
			const spSubMenu = () => {
				if (FUNCTIONS.va.window.width <= FUNCTIONS.va.device.desktop) {
					$headerSubMenu.forEach((ele) => {
						ele.addEventListener('click', (e) => {
							e.preventDefault();
							if (ele.classList.contains(a)) {
								ele.classList.remove(a);
								ele.nextElementSibling.classList.remove(a);
								ele.nextElementSibling.style.height = null;
								ele.closest('.__menu__megaMenu').style.height = (ele.closest('.__menu__megaMenu').scrollHeight - ele.nextElementSibling.scrollHeight) + 'px';
							} else {
								ele.classList.add(a);
								ele.nextElementSibling.classList.add(a);
								ele.nextElementSibling.style.height = ele.nextElementSibling.scrollHeight + 'px';
								ele.closest('.__menu__megaMenu').style.height = (ele.closest('.__menu__megaMenu').scrollHeight + ele.nextElementSibling.scrollHeight) + 'px';
							}
						});
					});
				}
			};
			spSubMenu();

			// 検索モーダル
			const siteSearch = () => {
				$siteSearch.addEventListener('click', () => {
					$searchModal.classList.add(a);
					setTimeout(() => { $searchModal.classList.add(v); });
				});
				$searchModal.querySelector('.__closeArea').addEventListener('click', () => {
					$searchModal.classList.remove(v);
					setTimeout(() => { $searchModal.classList.remove(a); }, 400);
				});
			};
			if ($siteSearch) {
				siteSearch();
			}

			// スクロール時表示ON/OFF
			const hiddenHeaderOnScroll = () => {
				let this_pos = 0;
				document.body.classList.add('is-top');
				window.addEventListener('scroll', () => {
					if (document.documentElement.scrollTop === 0) {
						document.body.classList.add('is-top');
						document.body.classList.remove('is-scroll');
					} else if (this_pos < document.documentElement.scrollTop) {
						document.body.classList.remove('is-top');
						document.body.classList.add('is-scroll');
					} else {
						document.body.classList.remove('is-top');
						document.body.classList.remove('is-scroll');
					}
					this_pos = document.documentElement.scrollTop;
				});
			};
			hiddenHeaderOnScroll();

			// 言語切替
			const langSwitch = () => {
				// 検証と本番サイトで遷移先を切り替え
				let thisHost = location.host;
				if (thisHost !== 'www.teraokaseiko.com' && thisHost !== 'www.digisystem.com' && thisHost !== 'www.digisystem.com.cn') {
					document.querySelectorAll('.__lang__body a').forEach((ele) => {
						let href = '/';
						if (ele.attributes.href.value.split('/')[3]) { href += `${ele.attributes.href.value.split('/')[3]}/`; }
						if (ele.attributes.href.value.split('/')[4]) { href += `${ele.attributes.href.value.split('/')[4]}/`; }
						ele.attributes.href.value = href;
					});
				}

				// プルダウン
				$langNavHead.addEventListener('click', () => {
					if ($langNavBody.classList.contains(a)) {
						$langNavBody.classList.remove(v);
						setTimeout(() => { $langNavBody.classList.remove(a); }, 300);
					} else {
						$langNavBody.classList.add(a);
						setTimeout(() => { $langNavBody.classList.add(v); });
						// メガメニューは閉じる
						if (FUNCTIONS.va.window.width > FUNCTIONS.va.device.desktop) {
							$headerMegaNav.forEach((ele2) => {
								if (ele2.nextElementSibling.classList.contains(a)) {
									ele2.classList.remove(a);
									ele2.nextElementSibling.classList.remove(v);
									setTimeout(() => { ele2.nextElementSibling.classList.remove(a); }, 300);
								}
							});
							$overlay.classList.remove(v);
							setTimeout(() => { $overlay.classList.remove(a); }, 300);
						}
					}
				});
			};
			langSwitch();

			// /company/showroom/ など、該当ページ上でアンカーリンクの処理
			document.querySelectorAll('.__megaMenu__flex__item__body a').forEach((ele) => {
				if (ele.attributes.href.value.indexOf('#') !== -1 && ele.attributes.href.value.split('#')[0] === FUNCTIONS.va.pathname) {
					ele.setAttribute('href', '#' + ele.attributes.href.value.split('#')[1]);
					ele.setAttribute('rel', 'scroll');
				}
			});
			// SPの場合メガメニューを閉じてスクロールさせる
			if (FUNCTIONS.va.window.width <= FUNCTIONS.va.device.desktop) {
				document.querySelectorAll('.__megaMenu__flex__item__body a[rel="scroll"]').forEach((ele) => {
					ele.addEventListener('click', () => {
						$hamburger.classList.toggle(a);
						$header.classList.remove('is-open');
						$headerNav.classList.remove(v);
						setTimeout(() => {
							$headerNav.classList.remove(a);
							this.fixedOffContainer(0);
							window.scrollTo({ top: document.getElementById(ele.attributes.href.value.replace(/#/, '')).getBoundingClientRect().top, behavior: 'smooth' });
						}, 400);
					});
				});
			}
		},
		textOverflow() {
			document.querySelectorAll('.js-textOverflow').forEach((ele) => {
				if (ele.scrollHeight > ele.clientHeight) {
					ele.classList.add('is-over');
				}
			});
		},
		matchHeight() {
			const $elements = document.querySelectorAll('[data-mh]');
			const groups = new Map();

			$elements.forEach(ele => { ele.style.height = 'auto'; }); // 初期化

			$elements.forEach(ele => {
				const attributeName = ele.getAttribute('data-mh');
				const topPosition = ele.getBoundingClientRect().top;

				const key = attributeName + '_' + topPosition;
				if (!groups.has(key)) {
					groups.set(key, []);
				}
				groups.get(key).push(ele);
			});
			groups.forEach(group => {
				const maxHeight = Math.max(...group.map(ele => ele.offsetHeight));
				group.forEach(ele => {
					ele.style.height = `${maxHeight}px`;
				});
			});
		},
		inViewAnimation () {
			const target = document.querySelectorAll('.js-fade');
			const options = {
				root: null,
				rootMargin: '-30% 0px',
				threshold: 0
			};
			const callback = (entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						entry.target.classList.add(v);
					}
				});
			};
			const observer = new IntersectionObserver(callback, options);
			target.forEach(ele => {
				observer.observe(ele);
			});
		},
		shareLinks() {
			let $share = document.querySelectorAll('.js-share');
			if ($share) {
				let url = encodeURIComponent(document.URL);
				let title = encodeURIComponent(document.title);
				$share.forEach(ele => {
					let thisURL = ele.getAttribute('href');
					ele.setAttribute('href', thisURL.replace(/#link/ig, url).replace(/#text/ig, title));
				});
			}
		},
		removeTagEmpty() {
			document.querySelectorAll('.mod-tagList li').forEach(ele => {
				if(!ele.querySelector('a, span')) { ele.remove(); }
			});
		},
		removeElmIfEmpty() {
			let $eleList = document.querySelectorAll('.js-checkEmptyElm');
			$eleList.forEach(ele => {
				if (!ele.textContent.length) {
					ele.remove();
				}
			});
		},
		removeBlockIfListEmpty() {
			let $eleList = document.querySelectorAll('.js-checkEmptyList');
			if ($eleList) {
				$eleList.forEach(ele => {
					if (!ele.getElementsByTagName('li').length) {
						ele.closest('.js-checkEmptyList-wrap').remove();
					}
				});
			}
		},
		redirect() {
			// Case Studies ⇒ 各事業配下へ
			if (FUNCTIONS.va.pathname === `${FUNCTIONS.va.region}case-studies/` || FUNCTIONS.va.pathname === `${FUNCTIONS.va.region}case-studies/index.html`) {
				let targetURL = '';
				switch (location.hash) {
					case '#tabContent1': targetURL = `${FUNCTIONS.va.region}retail/case-studies/`; break;
					case '#tabContent2': targetURL = `${FUNCTIONS.va.region}food-industry/case-studies/`; break;
					case '#tabContent3': targetURL = `${FUNCTIONS.va.region}logistics/case-studies/`; break;
					case '#tabContent4': targetURL = `${FUNCTIONS.va.region}hospitality/case-studies/`; break;
					default: targetURL = `${FUNCTIONS.va.region}retail/case-studies/`; break;
				}
				if (FUNCTIONS.va.region === '/jp/' && location.hash === '#tabContent3') {
					targetURL = '/jp/l/logistics/case/';
				}
				location.replace(targetURL);
			}
		},
		loadDelayScript() {
			let _this = this;

			_this.redirect();

			if (document.querySelector('.header')) { _this.header(); }

			_this.nextToggle();
			_this.tabSwitch();
			_this.easeScroll();
			// _this.easeScrollHash(); // スクロール中はヘッダーが消えるため不要
			_this.footerContactPos();
			_this.setImgAttrWidthHeight();
			_this.setModal();
			_this.textOverflow();
			_this.inViewAnimation();
			_this.shareLinks();
			_this.removeTagEmpty();
			_this.removeElmIfEmpty();
			_this.removeBlockIfListEmpty();

			let resizeTime = 0;
			window.addEventListener('load', () => { _this.matchHeight(); });
			window.addEventListener('resize', () => {
				clearTimeout(resizeTime);
				resizeTime = setTimeout(() => { _this.matchHeight(); }, 300);
			});
		}
	};

	document.addEventListener('DOMContentLoaded', () => FUNCTIONS.localDecision() ? FUNCTIONS.localLoading() : FUNCTIONS.loadDelayScript());
})();
